import type { SidebarItem } from './types';

export const API_URL = process.env.REACT_APP_API_URL || '';

// Sidebar items (left column of the app)
export const SIDEBAR_TOP: SidebarItem[] = [
  { id: 'create',    label: 'Create',    href: '#create',       icon: 'create' },
  { id: 'bookmarks', label: 'Bookmarks', href: '/bookmarks',    icon: 'bookmark' },
  { id: 'home',      label: 'Home',      href: '/',             icon: 'home' },
  { id: 'reports',   label: 'Reports',   href: '/reports',      icon: 'reports' },
  { id: 'all-apps',  label: 'All apps',  href: '/apps',         icon: 'apps' },
];

export const SIDEBAR_PINNED: SidebarItem[] = [
  { id: 'accounting', label: 'Accounting', href: '/accounting', icon: 'accounting', pinned: true },
];

export const SIDEBAR_BOTTOM: SidebarItem[] = [
  { id: 'more',      label: 'More',      href: '#more',         icon: 'more' },
  { id: 'customize', label: 'Customize', href: '#customize',    icon: 'customize' },
];

// Header search placeholder
export const SEARCH_PLACEHOLDER = 'Navigate. Find transactions, contacts, help, reports, and more.';

// Help menu items
export const HELP_LINKS: ReadonlyArray<{ label: string; href: string }> = [
  { label: 'Help center',       href: 'https://help.getnovala.com' },
  { label: 'Contact support',   href: '/support' },
  { label: 'Keyboard shortcuts', href: '#shortcuts' },
  { label: 'What is new',       href: '/changelog' },
];

// User menu items
export const USER_MENU: ReadonlyArray<{ label: string; href: string; danger?: boolean }> = [
  { label: 'My account',     href: '/account' },
  { label: 'Billing',        href: '/billing' },
  { label: 'Switch company', href: '/companies' },
  { label: 'Sign out',       href: '/logout', danger: true },
];

export const NOTIFICATION_POLL_MS = 60_000;
